var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.2356V8.11789L12 1.05908L0 8.11789V10.2356H2.11762V20.8238H0.705891V22.9415H23.2941V20.8238H21.8823V10.2356H24ZM7.7647 18.7062H4.94119V10.2356H7.7647V18.7062ZM13.4118 18.7062H10.5883V10.2356H13.4118V18.7062ZM12 8.11789C10.8305 8.11789 9.88238 7.16975 9.88238 6.00027C9.88238 4.83079 10.8305 3.88264 12 3.88264C13.1695 3.88264 14.1176 4.83079 14.1176 6.00027C14.1176 7.16975 13.1695 8.11789 12 8.11789ZM19.0588 18.7062H16.2353V10.2356H19.0588V18.7062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.c2c08d7566f2e28cafbd6c9e8169ddad.svg";
export { ForwardRef as ReactComponent };